import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { Form, Select } from 'antd';
import { disabledDate, disabledTime } from '../../utils/getPastTime';
import { CardTitle, DefaultRangePicker, getColor, getSize } from '@lib/common';
import moment from 'moment';
import { StyledInputNumber, StyledRequiredMark, renderDescriptionInput, renderExpectationItem, renderPasswordInput, renderShowExplanationSwitchOption, renderShuffleAnswerOption, renderShuffleQuestionOption, renderTitleInput } from './base-options.component';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Option = Select.Option;
var StyledWrapper = styled.div.withConfig({
  displayName: "create-practice-optionscomponent__StyledWrapper",
  componentId: "sc-z5p9mk-0"
})(["background-color:", ";padding:", ";border:1px solid #e6e8f0;border-radius:8px;margin-bottom:", ";"], getColor('fillBgSub'), getSize('gap24'), getSize('gap24'));
export var CreatePracticeOptions = function CreatePracticeOptions(props) {
  var label = props.label,
      errorLabel = props.errorLabel;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(StyledWrapper, {
      children: [/*#__PURE__*/_jsx(CardTitle, {
        children: label.basicInformation
      }), renderTitleInput(label, errorLabel), renderDescriptionInput(label)]
    }), /*#__PURE__*/_jsxs(StyledWrapper, {
      children: [/*#__PURE__*/_jsx(CardTitle, {
        children: label.timeAndAttempts
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("span", {
            children: label.durationAssignment
          }), /*#__PURE__*/_jsx(StyledRequiredMark, {
            children: "*"
          })]
        }),
        name: "duration",
        initialValue: 30,
        dependencies: ['rangeDate'],
        required: true,
        rules: [function (_ref) {
          var getFieldValue = _ref.getFieldValue;
          return {
            validator: function () {
              var _validator = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, value) {
                var isValidRange, diffRangeDate, rangeDate, isDurationLessThanDateRange;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        isValidRange = value && value < 1;

                        if (!isValidRange) {
                          _context.next = 3;
                          break;
                        }

                        return _context.abrupt("return", Promise.reject(errorLabel.durationIsNotValid));

                      case 3:
                        rangeDate = getFieldValue('rangeDate');

                        if (rangeDate && rangeDate.length === 2) {
                          diffRangeDate = moment(rangeDate[1]).startOf('minute').diff(moment(rangeDate[0]).startOf('minute'), 'minutes');
                        }

                        isDurationLessThanDateRange = getFieldValue('rangeDate') && value > diffRangeDate;

                        if (!isDurationLessThanDateRange) {
                          _context.next = 8;
                          break;
                        }

                        return _context.abrupt("return", Promise.reject(errorLabel.durationMustLessThanDiffRangeOfStartAndEndTime));

                      case 8:
                        return _context.abrupt("return", Promise.resolve());

                      case 9:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              function validator(_x, _x2) {
                return _validator.apply(this, arguments);
              }

              return validator;
            }()
          };
        }],
        children: /*#__PURE__*/_jsx(StyledInputNumber, {
          min: 0,
          addonAfter: label.minute
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "rangeDate",
        label: label.deadline,
        dependencies: ['duration'],
        rules: [{
          required: false,
          message: errorLabel.selectDeadlineMessage
        }, function (_ref2) {
          var getFieldValue = _ref2.getFieldValue;
          return {
            validator: function validator(_, value) {
              var diffRangeDate;

              if (value && value.length === 2) {
                diffRangeDate = moment(value[1]).startOf('minute').diff(moment(value[0]).startOf('minute'), 'minutes');
              }

              if (!value || getFieldValue('duration') <= diffRangeDate) {
                return Promise.resolve();
              }

              return Promise.reject(new Error("".concat(errorLabel.warningStartAndEndTime, "!")));
            }
          };
        }],
        children: /*#__PURE__*/_jsx(DefaultRangePicker, {
          disabledDate: disabledDate,
          disabledTime: disabledTime,
          showTime: {
            format: 'HH:mm'
          },
          format: "DD/MM/YYYY - HH:mm",
          placeholder: [label.startTime, label.endTime]
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "numberOfSubmission",
        label: label.maxNumberOfSubmission,
        initialValue: -1,
        rules: [{
          required: true,
          message: errorLabel.missingNumberOfSubmission
        }],
        children: /*#__PURE__*/_jsxs(Select, {
          size: "middle",
          placeholder: label.numberOfSubmissionPlaceholder,
          children: [/*#__PURE__*/_jsx(Option, {
            value: 1,
            children: "1"
          }), /*#__PURE__*/_jsx(Option, {
            value: 2,
            children: "2"
          }), /*#__PURE__*/_jsx(Option, {
            value: 3,
            children: "3"
          }), /*#__PURE__*/_jsx(Option, {
            value: -1,
            children: label.unlimitedNumberOfEditSubmission
          })]
        })
      })]
    }), /*#__PURE__*/_jsxs(StyledWrapper, {
      children: [/*#__PURE__*/_jsx(CardTitle, {
        children: label.shareAndAccess
      }), renderPasswordInput(label, errorLabel)]
    }), /*#__PURE__*/_jsxs(StyledWrapper, {
      children: [/*#__PURE__*/_jsx(CardTitle, {
        children: label.shuffleSettings
      }), renderShuffleQuestionOption(label), renderShuffleAnswerOption(label)]
    }), /*#__PURE__*/_jsxs(StyledWrapper, {
      children: [/*#__PURE__*/_jsx(CardTitle, {
        children: label.scoringAndResults
      }), renderShowExplanationSwitchOption(label), renderExpectationItem(label, errorLabel)]
    })]
  });
};